<template>
    <infinite-scroller-horizontal title="Stories" @scrolledTillRight="scrolledTillRight">
        <template>
            <v-col v-for="(n,index) in listItems" :key="'stor-' + index">
                <v-card flat class="text-center" color="transparent" width=80>
                    <v-badge color="purple" overlap right>
                        <template v-slot:badge>
                            <span>5</span>
                        </template>
                        <v-avatar size="50" color="blue">
                            <span class="white--text headline">A</span>
                        </v-avatar>
                    </v-badge>
                    <v-card-subtitle class="pa-1 text-center card--title-single-line">
                        Arun
                    </v-card-subtitle>
                    <v-card-actions class="pa-0">
                        <v-btn small >
                            Follow
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </template>
    </infinite-scroller-horizontal>
</template>
<script>
export default {
    data: () => ({
        listItems: 10
    }),
    methods: {
        profile() {},

        scrolledTillRight(val) {
            if (val) {
                this.listItems += 10
            }
        }
    }
}
</script>